import React from 'react';
import type { FC } from 'react';

interface ListIconProps {
    className?: string;
}

export const ListIcon: FC<ListIconProps> = ({ className }) => {
    return (
        <svg
            className={className}
            width="21"
            height="20"
            viewBox="0 0 21 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>List Icon</title>
            <path
                d="M2.875 4.66667C2.875 4.22464 3.05059 3.80072 3.36316 3.48816C3.67572 3.17559 4.09964 3 4.54167 3H15.5417C15.9837 3 16.4076 3.17559 16.7202 3.48816C17.0327 3.80072 17.2083 4.22464 17.2083 4.66667V14.6667C17.2083 15.1087 17.0327 15.5326 16.7202 15.8452C16.4076 16.1577 15.9837 16.3333 15.5417 16.3333H4.54167C4.09964 16.3333 3.67572 16.1577 3.36316 15.8452C3.05059 15.5326 2.875 15.1087 2.875 14.6667V4.66667Z"
                stroke="#8E8D93"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M7.04297 3V16.3333" stroke="#8E8D93" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};
